import { IOperation } from './i-operation';

export class PropertyOperation implements IOperation {
  protected _propertyChain: string[];

  constructor(protected _host: any, property: string, protected _oldValue: any, protected _newValue: any) {
    this._propertyChain = this.getPropertyChain(property);
  }

  public getQualifiedClassName(): string {
    return 'PropertyOperation';
  }

  public getOperationDescription(): string {
    return '';
  }

  public get host(): any {
    return this._host;
  }

  public get propertyChain(): string[] {
    return this._propertyChain;
  }

  public get oldValue(): any {
    return this._oldValue;
  }

  public get newValue(): any {
    return this._newValue;
  }

  private getPropertyChain(value: string): string[] {
    if (value.indexOf('.') !== -1) {
      return value.split('.');
    } else {
      return [value];
    }
  }

  protected setValue(value: any): void {
    if (!this._host || this._propertyChain.length === 0) {
      return;
    }
    let obj: any = this._host;
    let i: number = 0;
    while (obj && i < this._propertyChain.length - 1) {
      if (obj.hasOwnProperty(this._propertyChain[i])) {
        obj = obj[this._propertyChain[i]];
      }
      i++;
    }
    if (obj) {
      obj[this._propertyChain[this._propertyChain.length - 1]] = value;
    }
  }

  public async performRedo(): Promise<void> {
    this.setValue(this._newValue);
  }

  public async performUndo(): Promise<void> {
    this.setValue(this._oldValue);
  }

  public toString(): string {
    return 'Host: ' + this._host + '\nProperty: ' + this._propertyChain + '\n' + this._oldValue + '\n' + this._newValue;
  }

  public equals(obj: any): boolean {
    if (
      obj instanceof PropertyOperation &&
      obj.getQualifiedClassName() === this.getQualifiedClassName() &&
      this._host === obj.host &&
      this._oldValue === obj.oldValue &&
      this._newValue === obj.newValue &&
      this._propertyChain.length === obj.propertyChain.length
    ) {
      for (let i: number = 0; i < this._propertyChain.length; i++) {
        if (this._propertyChain[i] !== obj.propertyChain[i]) {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  }
}
